import { styled } from "styled-components";

export const SearchSectionContainer = styled.div`
    width: 100%;
    height: 200px;

    background: linear-gradient(
            to bottom,
            ${({ theme }) => `${theme.colors.primary[950]} 50%`}, ${({ theme }) => theme.colors.base} 0%
    );
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${({ theme }) => theme.breakpoints.md.query} {
        height: 100px;

`;

export const MiniSearchSectionContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 300px;
  align-self: stretch;
  height: 40px;
  padding: 8px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 100px;
  background: ${({ theme }) => theme.colors.default[50]};
  position: relative;
  color: ${({ theme }) => theme.colors.default[400]};

  & input {
    width: 100%;
    background: transparent;
  }
`;

export const Arch = styled.div`
  color: ${({ theme }) => theme.colors.base};
  display: block;
  overflow: hidden;
  position: absolute;
  top: 10px;
  margin-bottom: 0px;

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SearchCardContainer = styled.div`
  max-width: 1024px;
  width: 100%;
  padding: 24px;
  gap: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
  border-radius: 12px;
  display: flex;
  margin: 0 12px;
  z-index: 3;
  position: relative;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
    gap: 12px;
  }
`;
export const SearchCardButtonContainer = styled.div`
  display: flex;
  width: 87px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    width: 100%;
  }
`;

export const SearchResultsWrapper = styled.div<{
  $active?: boolean;
  $mini?: boolean;
}>`
  width: 100%;
  position: absolute;
  top: ${({ $mini }) => ($mini ? "45px" : "100px")};
  left: 0;
  z-index: 3;
  display: ${({ $active }) => ($active ? "flex" : "none")};
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e2e3e5;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 8px 25px 0px rgba(13, 17, 43, 0.1);
  backdrop-filter: blur(10px);
  max-height: 258px;
`;

export const SearchResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: scroll;
`;

export const SearchResult = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.default[950]};
  text-overflow: ellipsis;

  &:hover {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  & > a {
    width: 100%;
    height: 100%;
  }
`;

export const NoResults = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  & a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;
